'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/waveforms", "/waveforms/list");
  $stateProvider
    .state('waveforms', {
      url: '/waveforms',
      template: require('./waveforms.html'),
      authenticate: true
    })
    .state('waveforms.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'WaveformsListController',
      controllerAs: 'waveformsListCtrl'
    })
    .state('waveforms.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'WaveformsEditController',
      controllerAs: 'waveformsEditCtrl'
    })
    .state('waveforms.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'WaveformsAddController',
      controllerAs: 'waveformsAddCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/waveforms/waveforms.routes.js